<script>
export default {
    name: 'BaseRadioGroup',
};
</script>

<script setup>
const props = defineProps({
    value: {
        type: [String, Number, Boolean],
    },
    options: {
        type: Array,
    },
    name: {
        type: String,
    },
    disabled: {
        type: Boolean,
    },
    deselectable: {
        type: Boolean,
    },
    itemClass: {
        type: String,
    },
});

const emit = defineEmits({
    input: null,
    change: null,
});

function change(option) {
    if (props.disabled) return;

    let value = option.value;

    if (props.deselectable && option.value === props.value) {
        value = null;
    }

    emit('input', value);
    emit('change', value, option);
}
</script>

<template>
    <div class="flex flex-wrap">
        <base-radio
            v-for="option in options"
            :key="option.value"
            :name="name"
            :checked="option.value === value"
            :value="option.value"
            :label="option.label"
            :disabled="disabled || !!option.disabled"
            :type="option.type"
            :class="itemClass || 'p-3'"
            @change="change(option)"
        >
            <slot :option="option" />

            <template #content>
                <slot name="option-content" :option="option" />
            </template>
        </base-radio>
    </div>
</template>
